import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useAssetProfileStats } from "routes/facilities/controller/asset-profile-stats"
import { Bound } from "lib/@components/binding/Bound"
import { Box } from "@mui/material"
import TableSkeleton from "minimals-template/components/table/TableSkeleton"

import { AssetProfileDetails } from "routes/asset-profile/asset-profile-details"

export function Profile() {
    const { parentItem } = useBoundContext()
    const stats = useAssetProfileStats(parentItem.id, [parentItem.id])
    // getModelStats can take several seconds for large regimes; show a table skeleton rather than a blank panel
    if (!stats) {
        return (
            <Box data-cy="profile-loading" sx={{ pt: 1 }}>
                <TableSkeleton rowCount={8} dense />
            </Box>
        )
    }
    return (
        <Bound stats={stats}>
            <AssetProfileDetails />
        </Bound>
    )
}
